import { render, staticRenderFns } from "./BrandSearchBar.vue?vue&type=template&id=d01c2e54&scoped=true"
import script from "./BrandSearchBar.vue?vue&type=script&lang=ts"
export * from "./BrandSearchBar.vue?vue&type=script&lang=ts"
import style0 from "./BrandSearchBar.vue?vue&type=style&index=0&id=d01c2e54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01c2e54",
  null
  
)

export default component.exports